module.exports = __webpack_public_path__ + "static/media/ic_close.03af5f67.svg";